// Data preservation utility function - prevents overwriting existing data with null/empty values
export default (newData = {}, existingData = {}, fieldsToPreserve = []) => {
  const preserved = { ...newData };
  
  // Default fields that should be preserved if they become null/empty
  const defaultPreserveFields = [
    'bio', 'display_name', 'firstname', 'website', 'contact_email', 'contact_whatsapp', 
    'contact_link', 'management_company', 'public_email', 'country', 'city',
    'youtube_channel', 'youtube_username', 'language', 'gender'
  ];
  
  const allFieldsToPreserve = [...defaultPreserveFields, ...fieldsToPreserve];
  
  allFieldsToPreserve.forEach(field => {
    const newValue = newData[field];
    const existingValue = existingData[field];
    
    // If new value is null, undefined, empty string, or just whitespace
    // and existing value has actual content, preserve the existing value
    if (
      (newValue === null || newValue === undefined || 
       (typeof newValue === 'string' && newValue.trim() === '')) &&
      existingValue !== null && existingValue !== undefined &&
      (typeof existingValue !== 'string' || existingValue.trim() !== '')
    ) {
      preserved[field] = existingValue;
      console.log(`📋 Preserving existing ${field}: "${existingValue}" (API returned empty)`);
    }
  });
  
  return preserved;
};